/* SaGó — oculta el header al bajar y lo muestra al subir.
   Extraído de sections/header.liquid (bloque <script> inline).
   Se carga con defer: el DOM ya existe cuando se ejecuta. */

let lastScroll = 0;
const header = document.querySelector('.custom-header2026');
const scrollThreshold = 80;

window.addEventListener('scroll', () => {

  const currentScroll = window.pageYOffset;

  if (currentScroll > lastScroll && currentScroll > scrollThreshold) {
    // scroll hacia abajo → ocultar
    header.style.transform = "translateY(-100%)";
  } else {
    // scroll hacia arriba → mostrar
    header.style.transform = "translateY(0)";
  }

  lastScroll = currentScroll;

});

/* SaGó · menú propio del header (E5) — cerrar el desplegable con Escape.

   El resto del comportamiento no necesita JavaScript nuevo: el marcado es
   <details> dentro de <header-menu>, que es el custom element que Dawn ya carga
   en todas las páginas (assets/details-disclosure.js). De ahí sale abrir y
   cerrar al pulsar, y cerrar al salir el foco.

   Lo único que no trae es Escape, y sin eso el desplegable es una trampa para
   quien navega con teclado: se abre y no hay forma de cerrarlo sin tabular
   hasta el final. Se engancha en el documento y no por menú porque el marcado
   sólo existe cuando el ajuste está encendido. */
document.addEventListener('keydown', (evento) => {
  if (evento.key !== 'Escape') return;

  document
    .querySelectorAll('.custom-header2026 .sago-menu2026 details[open]')
    .forEach((desplegable) => {
      desplegable.removeAttribute('open');
      // Devolver el foco al <summary>: si se queda dentro de lo que se acaba
      // de cerrar, el navegador lo manda al principio de la página.
      desplegable.querySelector('summary')?.focus();
    });
});
